import {useEffect, useRef} from "react";
import {getUser} from "@/common/utils.ts";
import {getTaskId, getTaskLimit} from "@/services/saleOpServices.ts";
import {useSetState} from "ahooks";
import dayjs from "dayjs";
import {STitle} from "shj-components";
import styles from "@/pages/salesWorkbench/workbenchList/index.module.less";
import {Button, message} from "antd";
import noTaskIcon from "@/assets/noTask.svg";
import {openInNewTab} from "@/utils/queryParse.ts";
import TaskModal from "@/pages/salesWorkbench/workbenchList/dialog/taskModal.tsx";

const EmergencyTask = (props) => {
  const {
    reload = () => {},
  } = props;

  const intervalId = useRef<any>()

  // 创建一个状态数组来存储每个任务的剩余时间
  const [state, setState] = useSetState<any>({
    open: false,
    taskList: []
  })
  const defaultTaskNameMap = {
    NO_RESPOND: '未响应',
    NO_FOLLOW: '未有效',
  }

  useEffect(() => {
    fetchTaskLimit()
    const startInterval = () => {
      intervalId.current = setInterval(() => {
        fetchTaskLimit();
      }, 10000); // 每5秒请求一次
    };
    startInterval();
    // 组件卸载时清除定时器
    return () => {
      if (intervalId) {
        clearInterval(intervalId.current);
      }
    };
  }, []);

  const fetchTaskLimit = async () => {
    const user = getUser();
    const res: any = await getTaskLimit(user?.ucenterUserId, 2)
    if (Array.isArray(res)) {
      if (res?.length === 0 && state.taskList?.length === 0) {
        return;
      }
      setState({ taskList: res });
    }
  }

  const handleDetail = (id) => {
    openInNewTab(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${id}`)
  }

  const onTaskClick = () => {
    setState({open: true})
  }
  const handleTask = async (data: any) => {
    const res: any = await getTaskId(data?.id);
    if (res['state'] == 'PROCESSED') {
      message.warning('任务已完成或者线索已被改派，无需再处理');
      return;
    } else {
      openInNewTab(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${data.clueId}`)
    }
  }

  return <>
    <STitle
        title={
          <div className={styles.title}>
            <strong>
              紧急任务
              <span className={styles.count}>{state.taskList.length}条</span>
            </strong>
            {state.taskList.length > 0 ? <Button style={{color: '#575859'}} type="link" onClick={onTaskClick}>
              查看更多
            </Button> : ''}
          </div>
        }
    />
    <div style={{overflow: "hidden"}}>
      {state.taskList?.length > 0 ? state.taskList?.map?.((d: any, i) => {
        return (
            <div key={`item_${i}`} style={{ marginBottom: '2px' }} className={styles.taskItem}>
              <div className={styles.taskItemBox}>
                <p style={{ fontWeight: 600, fontSize: '14px', color: 'red' }}>{defaultTaskNameMap[d.taskType]}，即将改派！！！</p>
                {d.taskTypeName == '未响应' ? '' : dayjs(d.expirationTime).diff() > 0 ? <Button style={{color: '#EB3723'}} type="link" size="small" onClick={() => { handleTask(d) }}>
                  立即处理
                </Button> : <Button type="link" size="small" disabled>
                  立即处理
                </Button>}

              </div>
              <p style={{ color: '#323232', marginTop: 4 }}>线索ID：<Button style={{padding: 0, height: 'inherit'}} type={"link"} onClick={() => handleDetail(d.clueId)}>{d.clueId}</Button>，客户：{d.customerName}，手机号码：{d.customerPhone}  即将改派 ！</p>
            </div>

        );
      }) : <div className={styles.noDataText}>
        <img src={noTaskIcon} alt="" style={{ height: '100px' }} />
      </div>}
    </div>
    {state.open ? <TaskModal open={state.open}
                             onClose={() => {
                               setState({open: false})
                             }}
                             reload={reload}
                  /> : null}
  </>
}

export default EmergencyTask